import React from 'react';
import { useTranslation } from 'react-i18next';

const SplashScreen = () => {
    const { t } = useTranslation();

    return (
        <div className="splash-screen-container">
            <div className="harmony-orb" />
            <h1 className="splash-title">{t('splashScreen.title')}</h1>
            <p className="splash-loading-text">{t('splashScreen.loadingText')}</p>
        </div>
    );
};

export default SplashScreen;